import { ColumnFormat, ViewColumn } from 'common/types/viewColumn';

export const MAX_CUSTOM_SORT_UNIQUE_ROW_COUNT = 25;

export type ExportData = {
  columns: ViewColumn[];
  rows: unknown[];
  rowIds: unknown[];
};

export type UniqueValuesData = {
  rows: unknown[];
};

export interface ArgumentOption {
  end: string;
  start: string;
  value: string | number;
}

export interface Expression {
  arguments: ArgumentOption;
  function: string;
}

export interface FormatStyle {
  backgroundColor: string;
  color?: string;
  fontStyle?: FontStyle;
  fontWeight?: 'bold' | 'italic';
  textColor: string;
  textFont: string;
}

export interface TableColumnFormat {
  colorPalette: string;
  colorPaletteType: string;
  columnName: string;
  conditionStyle?: FormatStyle;
  conditionalConfig?: ConditionalConfig[];
  conditionalType: string;
  displayName: string;
  expression: Expression;
  format: ColumnFormat;
  isAlignHeader: boolean;
  isFormatSubtotal?: boolean;
  isFormatTotal: boolean;
  isFormatValue: boolean;
  style: FormatStyle;
}

export type FontStyle = {
  [key in FontStyleTypes]: boolean;
};

export interface ConditionalConfig {
  expression: Expression;
  style: FormatStyle;
}

export enum FontStyleTypes {
  isBold = 'isBold',
  isItalic = 'isItalic',
  isWrapped = 'isWrapped'
}
